// Description: Convert file size to human readable format
// previous function sAction.humanFileSize(bytes) works in binary format
// and converts differently than this function (OS-7MB file converts as 6.8MB)
// this function is based on https://stackoverflow.com/a/18650828/1015046 same as OS

export default function convertFileSize(bytes, si=true, dp=1) {
    if (!bytes) {
        return '--';
    }
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si ?
        ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] :
        ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
}
